import { useTheme } from "next-themes";
import { Toaster as Sonner, toast } from "sonner"; // Use original toast name
import { type ComponentProps } from "react";
import { CircleCheckIcon, InfoIcon, Loader2Icon, OctagonXIcon, TriangleAlertIcon } from "lucide-react";

type ToasterProps = ComponentProps<typeof Sonner>; // Simplified type

const Toaster = ( { ...props }: ToasterProps ) => { // Simplified props
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps[ "theme" ]}
      className="toaster group"
      aria-live="polite" // Added for WCAG
      duration={7000} // Added for WCAG
      closeButton={true} // Added to show close button
      {...props} // Pass all props directly
      icons={{
        success: <CircleCheckIcon className="size-8 text-[#107048]" />,
        info: <InfoIcon className="size-8 text-[#0079b8]" />,
        warning: <TriangleAlertIcon className="size-8 text-[#efba2a]" />,
        error: <OctagonXIcon className="size-8 text-[#be3e37]" />,
        loading: <Loader2Icon className="size-8 animate-spin" />,
      }}
      toastOptions={{
        classNames: {
          content: "ml-4",
          toast: `
            w-96 group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border group-[.toaster]:shadow-lg 
            data-[type=success]:!bg-[#def7ed] data-[type=success]:!border-[#7ecead] 
            data-[type=error]:!bg-[#f6e6e5] data-[type=error]:!border-[#e3aeab] 
            data-[type=warning]:!bg-[#fcf6e3]  data-[type=warning]:!border-[#f7dd97] 
            data-[type=info]:!bg-[#e3e9f7] data-[type=info]:!border-[#b0c1e8]
          `,
          title: "group-[.toast]:text-neutral-900",
          description: "group-[.toast]:text-neutral-800",
          closeButton:
            "!bg-primary !border-primary text-white rounded-full hover:!bg-primary/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 h-7 w-7 inline-flex items-center justify-center [&_svg]:text-white",
        },
      }}
    />
  );
};

export { Toaster, toast }; // Export original toast
